module.exports = __webpack_public_path__ + "static/media/icon-offer-fleet.c7d82582.svg";